import React, { useEffect } from "react";
import { Admin_Player_Details_GET, Get_Details_Agent_PlayerTemplate_GET } from "../../../api/ApiConst";
import { callGetApi } from "../../../api/ApiCaller";
import { useState } from "react";
import dateUtilities from "../../../utilities/DateUtilities";
import { Toaster } from "react-hot-toast";
import AgentPlayerWalletTransactionTab from "./AgentPlayerWalletTransactionTab";
import AgentPlayerGameSession from "./AgentPlayerGameSession";
import moduleUtilities from "../../../utilities/ModuleUtils";
import formatMoneyAmountUtils from "../../../utilities/FormatMoneyAmountUtils";
import AgentPokerSessionHistory from "./AgentPokerSessionHistory";

const allTabs = [
    "Wallet Transactions"
    // "Withdrawal History", "Deposit History", "Ludo Session History", "Poker Session History"
];

const AgentPlayerDetails = ({ rId, moduleList }) => {
    let playerID = rId;
    const [playerTabs, setPlayerTabs] = useState(allTabs);
    const [activeTab, setActiveTab] = useState(playerTabs[0]);
    const [record, setRecord] = useState({
        recordId: "",
        nickName: "",
        countryCode: "",
        mobileNumber: "",
        profileImageUrl: "",
        referralCode: "",
        walletBalance: 0,
        createdAtTimeStamp: "",
    });

    useEffect(() => {
        getPlayerDetails();
    }, []);

    useEffect(() => {
        // var tabList = allTabs;
        if (moduleList !== null && moduleList !== undefined && moduleList.length > 0) {
                if (!playerTabs.includes("Ludo Session History")) {
                    let tabs = playerTabs;
                    tabs.push("Ludo Session History");
                    setPlayerTabs(tabs);
                }
        }
    }, [moduleList]);

    const getPlayerDetails = () => {
        let url = Get_Details_Agent_PlayerTemplate_GET.replaceAll("{recordId}", playerID);
        callGetApi(
            url,
            {},
            (response) => {
                setRecord({
                    recordId: response.responsePacket.recordId,
                    fullName: response.responsePacket.fullName,
                    nickName: response.responsePacket.nickName,
                    dateOfBirth: response.responsePacket.dateOfBirth,
                    gender: response.responsePacket.gender,
                    countryCode: response.responsePacket.countryCode,
                    mobileNumber: response.responsePacket.mobileNumber,
                    profileImageUrl: response.responsePacket.profileImageUrl,
                    referralCode: response.responsePacket.referralCode,
                    walletBalance: response.responsePacket.walletBalance,
                    kycVerificationStatus: response.responsePacket.kycVerificationStatus,
                    createdAtTimeStamp: response.responsePacket.createdAtTimeStamp,
                });
            },
            (error) => {
                console.log(error);
            }
        );
    };

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Player Details</h4>
                                <div className="page-title-right"></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div id="datatable_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <div className="card p-3">
                                            <div className="row">
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div className="form-group mb-3 text-center">
                                                        <img className="playerDetailProfile" src={record?.profileImageUrl ? record?.profileImageUrl : "/assets/images/user.png"} alt="Player" />
                                                        <h5 className="mt-3">
                                                            <b>{record?.fullName}</b>
                                                        </h5>
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <div className="input-group">
                                                        <div className="input-group-addon">
                                                            <i className="bx bx-phone text-primary"></i>
                                                        </div>
                                                        <div className="form-control">
                                                            {record?.countryCode}
                                                            <span className="ms-1">{record?.mobileNumber}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <div className="input-group">
                                                        <div className="input-group-addon">
                                                            <i className="bx bx-calendar text-primary"></i>
                                                        </div>
                                                        <div className="form-control">
                                                            <span>{record?.dateOfBirth && dateUtilities.formattedDate(record?.dateOfBirth, "dd-MM-yyyy")}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <div className="d-flex justify-content-between form-control">
                                                        <div className="text-grey">Gender :</div>
                                                        <span className="text-primary ms-2 fw-bold">{record?.gender}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <div className="d-flex justify-content-between form-control">
                                                        <div className="text-grey">Wallet Balance:</div>
                                                        <span className="text-primary ms-2 fw-bold">{formatMoneyAmountUtils?.formatAmount(record?.walletBalance)}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group mb-2">
                                                    <div className="d-flex justify-content-between form-control">
                                                        <div className="text-grey">Referral Code:</div>
                                                        <span className="text-primary ms-2 fw-bold">{record?.referralCode}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" col-lg-9">
                                        <div className="card p-3">
                                            <nav>
                                                <div className="nav nav-tabs nav-tabs-custom mb-3" id="nav-tab" role="tablist">
                                                    {playerTabs.map((tab, i) => (
                                                        <a
                                                            key={i}
                                                            onClick={() => setActiveTab(tab)}
                                                            className={`nav-link ${tab === activeTab ? "active" : ""}`}
                                                            data-bs-toggle="tab"
                                                            data-bs-target="#nav-001"
                                                            type="button"
                                                            role="tab"
                                                            aria-selected={tab === activeTab ? "true" : "false"}
                                                        >
                                                            {tab}
                                                        </a>
                                                    ))}
                                                </div>
                                            </nav>
                                            <div className="tab-content border bg-light" id="nav-tabContent">
                                                <div className="tab-pane fade active show" id="nav-001" role="tabpanel" aria-labelledby="nav-001-tab">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="card mb-0">
                                                                <div className="card-body">
                                                                    <div className="table-rep-plugin custom-table">
                                                                        <div className="table-responsive mb-0" data-pattern="priority-columns">

                                                                            {activeTab === "Wallet Transactions" && <AgentPlayerWalletTransactionTab playerID={playerID} />}
                                                                            {/* {activeTab === "Withdrawal History" && <AgentPlayerWithdrawalTransactionTab playerID={playerID} />}
                                                                            {activeTab === "Deposit History" && <AgentPlayerDepositTransactionTab playerID={playerID} />} */}
                                                                            {activeTab === "Ludo Session History" && <AgentPlayerGameSession playerID={playerID} />}
                                                                            {activeTab === "Poker Session History" && <AgentPokerSessionHistory playerID={playerID} />}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default AgentPlayerDetails;
